import { render, staticRenderFns } from "./NewChildNode.vue?vue&type=template&id=dc31dca4&scoped=true&"
import script from "./NewChildNode.vue?vue&type=script&lang=js&"
export * from "./NewChildNode.vue?vue&type=script&lang=js&"
import style0 from "./NewChildNode.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NewChildNode.vue?vue&type=style&index=1&id=dc31dca4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc31dca4",
  null
  
)

export default component.exports